import script from "./ThePaymentMethodsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePaymentMethodsReport.vue?vue&type=script&setup=true&lang=js"

import "./ThePaymentMethodsReport.vue?vue&type=style&index=0&id=5055c48f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5055c48f"]])

export default __exports__